import styled from 'styled-components';
import { Button } from 'antd';
// Abstracts
import * as palette from '../../../styles/variables';

export const GridContainer = styled.header`
  margin-bottom: 2%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 10000;
  left: ${props => (props.messageStudio ? '50%' : '')};
  bottom: ${props => (props.messageStudio ? '0%' : '0px')};
  transform: ${props => (props.messageStudio ? 'translate(-50%, -50%)' : '')};
  border-radius: 10px;
  background-color: rgb(37, 41, 45);
  box-shadow: 0 15px 25px rgb(0 0 0 / 10%);
  border: 1px solid rgb(0 0 0 / 10%);
  opacity: 0;
  pointer-events: none;
  @media only screen and (min-width: 1450px) {
    height: 75px !important;
  }
  &.mailTemp {
    width: 25% !important;
    margin: 0 !important;
    margin-bottom: 1% !important;
  }
  &.email {
    margin-right: 2%;
  }
  &.visible {
    opacity: 1 !important;
  }
  &.enable {
    pointer-events: all;
    &:hover {
      opacity: 1 !important;
    }
  }
  svg {
    .icon {
      fill: none;
      stroke: #414856;
      stroke-dashoffset: 98;
      stroke-width: 2px;
      stroke-linecap: round;
      stroke-linejoin: round;
      @for $icon from 2 through 5 {
        $colors: none, #ffb400, #ff5100, #9901f8, #ffb400;
        &:nth-child(#{$icon}) {
          opacity: 0;
          stroke: nth($colors, $icon);
          animation-delay: 0.1s * $icon !important;
        }
      }
    }
  }
  input {
    display: none;
    &:checked {
      + label {
        &::before {
          animation: click-animation 0.4s ease forwards;
        }
        svg {
          .icon {
            &:first-child {
              animation: stroke-animation-first 0.5s linear forwards 0.5s;
            }
            @for $icon from 2 through 4 {
              &:nth-child(#{$icon}) {
                animation: stroke-animation 0.5s linear;
              }
            }
            &:last-child {
              animation: stroke-animation-last 0.5s linear forwards;
            }
          }
        }
      }
    }
  }
  @keyframes stroke-animation-first {
    0% {
      opacity: 1;
      stroke-dashoffset: 98;
      stroke-dasharray: 98 0;
    }
    100% {
      opacity: 0;
      stroke-dashoffset: 0;
      stroke-dasharray: 0 98;
    }
  }
  @keyframes stroke-animation {
    0% {
      opacity: 1;
      stroke-dashoffset: 98;
      stroke-dasharray: 0 98 0 0;
    }
    15% {
      stroke-dasharray: 0 98 18 0;
    }
    100% {
      opacity: 1;
      stroke-dashoffset: 0;
      stroke-dasharray: 0 98 18 0;
    }
  }
  @keyframes stroke-animation-last {
    0% {
      opacity: 1;
      stroke-dashoffset: 98;
      stroke-dasharray: 98 98 18 0;
    }
    15% {
      stroke-dasharray: 116 98 18 0;
    }
    100% {
      opacity: 1;
      stroke-dashoffset: 0;
      stroke-dasharray: 116 98 18 0;
    }
  }
  @keyframes click-animation {
    50% {
      transform: scale(4);
      opacity: 0.1;
    }
  }
`;
export const PinNavBar = styled.div`
  position: absolute;
  bottom: 60px;
  div {
    width: 50px;
    margin: 30px auto 5px;
  }
  @media only screen and (min-width: 1450px) {
    margin: 30px auto 15px !important;
  }
  div > span {
    border-radius: 50%;
    display: block;
    height: 30px;
    width: 30px;
    cursor: pointer;
    padding: 5px 3px 5px 8px;
    transition: background-color 0.25s;
  }
  @media only screen and (min-width: 1450px) {
    div > span {
      height: 40px !important;
      width: 40px !important;
    }
  }
  div > span > svg {
    height: 90%;
    transition: transform 0.25s;
  }
  div > span > svg path {
    fill: #666;
  }
  div > span:hover {
    background: #ededed;
  }
  div > span:hover > svg path {
    fill: #000;
  }
  div > span:active {
    transition: background-color 0s;
    box-shadow: inset 0 0 5px #fff;
  }
  div > span:active > svg path {
    fill: #fff;
  }
  div > span.pinned {
    background: #000;
    padding: 5px 4px 5px 7px;
  }
  div > span.pinned:hover {
    background: #000;
  }
  div > span.pinned:active {
    box-shadow: inset 0 0 5px #fff;
  }
  div > span.pinned > svg {
    transform: rotate(-45deg);
  }
  div > span.pinned > svg path {
    fill: #fff;
  }
`;
export const GridItem = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.WHITE_COLOR};
  height: 40px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content:  ${props => (props.enterprise ? 'space-around' : 'space-between')} ;
  column-gap:40px;
  padding:0px 20px;
  .ant-dropdown-trigger {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
    border-radius: 4px;
    @media (max-width: 768px) {
      padding: 0px;
    }
    &:hover {
      cursor: pointer;
      background-color: transparent;
    }
    &:first-child {
      margin: 0px;
      color: #000 !important;
    }
  }
  .lang-icon {
    svg {
      width: 30px;
      height: 30px;
    }
  }
  @media only screen and (min-width: 1450px) {
    svg {
      width: 25px !important;
      height: 25px !important;
    }
    .anticon {
      font-size: 25px !important;
    }
    .lang-icon {
      svg {
        width: 40px !important;
        height: 40px !important;
      }
    }
  }
  .ant-btn[disabled] {
    color: #fff !important;
    background-color: transparent !important;
    border-color: transparent !important;
    border: transparent !important;
    cursor: not-allowed !important;
  }
`;

export const DownloadButton = styled(Button)`
  font-weight: 600;
  display: flex !important;
  align-items: center;
  justify-content: center;
  background-color: transparent !important;
  background: transparent !important;
  color: #fff !important;
  border: 2px solid transparent !important;
  box-shadow: none !important;
  display: flex;
  flex-direction: column;
  padding: 0 !important;
  width: auto !important;
  &:hover,
  &:focus {
    background-color: transparent !important;
    color: #fff !important;
    border-color: transparent !important;
    box-shadow: none;
  }

  &.inactive {
    color: grey !important;
  }

  &.topMenu {
    border: 1px solid white !important;
    padding: 5px !important;

    &:hover, &:focus {
      color: #40a9ff !important;
      border-color: #40a9ff !important;
    }
  }
`;

export const ComplexContainer = styled.div` 
  display: flex;
  justify-content: ${props => props.email ? 'flex-end' : 'center'};
`;